import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

import { useUiStore } from '@/stores/ui';
import combinedReference from './combinedReference.vue';
import { createReferenceSheetTitle } from '@/functions/resultSuggestion.js';
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'refSheetGroup',
  props: {
  title: {
    type: String,
    default: "Conclusion",
  },
  refSheet: {
    type: Object,
    default: null,
  },
  resultReferenceType: {
    type: String,
    default: "Sheet",
  },
  showType: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const { t } = useI18n();
const uiStore = useUiStore()

const props = __props

function setRefSheetFromGroup() {
  uiStore.setReferenceTab(props.resultReferenceType)    //tabKey = Presentation, Etio, Complic, Treatment
  uiStore.setCurrRefSheet(props.refSheet)               //refSheet = Object (e.g.Diabète refSheet)
}


return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_dbGroup = _resolveComponent("dbGroup")!

  return (_openBlock(), _createElementBlock("div", _normalizeProps(_guardReactiveProps(_ctx.$attrs)), [
    (props.refSheet)
      ? (_openBlock(), _createBlock(_component_itemModal, {
          key: 0,
          center: true,
          uiId: 'referenceRecoGroup' + props.refSheet.appUserResultReferenceId
        }, {
          modal: _withCtx(() => [
            _createVNode(combinedReference)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_buttonGroup, {
              style: {"margin-left":"-0.35rem","padding-top":"0.15rem","padding-bottom":"0.15rem"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (setRefSheetFromGroup()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  style: {"margin-top":"0.1rem"},
                  icon: "bookOpen",
                  styles: "size-s main-l"
                }),
                _createVNode(_component_text_item, {
                  txt: _unref(createReferenceSheetTitle)(props.refSheet),
                  styles: "font-m main-l",
                  class: "mleft-04"
                }, null, 8, ["txt"]),
                (props.showType)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_text_item, {
                        txt: "-",
                        styles: "font-m main-l",
                        class: "mleft-04"
                      }),
                      _createVNode(_component_text_item, {
                        txt: _unref(t)(`refSheet.tabs.${props.resultReferenceType}`),
                        styles: "font-m main-l",
                        class: "mleft-04"
                      }, null, 8, ["txt"])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["uiId"]))
      : (_openBlock(), _createBlock(_component_text_item, {
          key: 1,
          txt: props.title,
          styles: "font-m main-l",
          style: {"margin-bottom":"0.15rem"}
        }, null, 8, ["txt"])),
    _createVNode(_component_dbGroup, { class: "mtop-01" }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })
  ], 16))
}
}

})